import { useEffect, useRef, useState } from 'react';
import { initOnRamp } from '@coinbase/cbpay-js';
import api from '../api';

export default function CoinbaseOnrampWidget({ onClose }) {
  const instanceRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const init = async () => {
      try {
        // Get secure session token from backend
        const { data } = await api.get('/coinbase/session-token');
        if (cancelled) return;

        initOnRamp(
          {
            appId: process.env.REACT_APP_CDP_PROJECT_ID,
            widgetParameters: {
              sessionToken: data.token,
              destinationWallets: [
                {
                  address: data.address,
                  blockchains: ['base'],
                  assets: ['USDC'],
                },
              ],
            },
            experienceLoggedIn: 'popup',
            experienceLoggedOut: 'popup',
            closeOnExit: true,
            closeOnSuccess: true,
            onSuccess: () => {
              onClose();
            },
            onExit: () => {
              onClose();
            },
            onEvent: (event) => {
              if (event.eventName === 'error') {
                console.error('Coinbase Onramp error:', event.error);
              }
            },
          },
          (err, instance) => {
            if (cancelled) return;
            if (err) {
              setError(err.message || 'Failed to initialize Coinbase Onramp');
              setLoading(false);
              return;
            }
            instanceRef.current = instance;
            setLoading(false);
          }
        );
      } catch (err) {
        if (cancelled) return;
        setError(err.response?.data?.error || 'Error connecting to Coinbase');
        setLoading(false);
      }
    };

    init();

    return () => {
      cancelled = true;
      instanceRef.current?.destroy();
    };
  }, [onClose]);

  const handleOpen = () => {
    instanceRef.current?.open();
  };

  if (error) {
    return (
      <div className="modal-overlay">
        <div className="modal-content">
          <div className="error-msg">{error}</div>
          <button className="btn btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="modal-overlay">
        <div className="modal-content">
          <div className="loading">Loading Coinbase Onramp...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <strong>Buy USDC with card</strong>
          <button className="modal-close-btn" onClick={onClose}>&times;</button>
        </div>
        <div style={{ padding: '32px 24px', textAlign: 'center' }}>
          <p style={{ marginBottom: 24, color: '#b0b0b0' }}>
            Purchase USDC on Base with your credit or debit card via Coinbase. Zero fees on USDC.
          </p>
          <button className="btn btn-primary" onClick={handleOpen} style={{ width: '100%', padding: '14px' }}>
            Open Coinbase
          </button>
        </div>
      </div>
    </div>
  );
}
